import { render, staticRenderFns } from "./WorkflowFormPassos.vue?vue&type=template&id=bec85a0c"
import script from "./WorkflowFormPassos.vue?vue&type=script&lang=js"
export * from "./WorkflowFormPassos.vue?vue&type=script&lang=js"
import style0 from "./WorkflowFormPassos.vue?vue&type=style&index=0&id=bec85a0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports